import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { getPlatformLinkUsingRouter } from '@bpm-web-app/utils';
import styles from './notification-banner.module.css';

const BANNER_STORAGE_KEY = 'notification-banner-dismissed';

export function NotificationBanner() {
    const [isVisible, setIsVisible] = useState(false);
    const router = useRouter();
    const isAccount = router.pathname.startsWith('/account');

    useEffect(() => {
        // Check if banner was previously dismissed
        const isDismissed = localStorage.getItem(BANNER_STORAGE_KEY);
        if (!isDismissed) {
            setIsVisible(true);
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        localStorage.setItem(BANNER_STORAGE_KEY, 'true');
    };

    const handleDealsClick = () => {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        router.push(getPlatformLinkUsingRouter(`/account/plan?library=${router.query['library']?.toString() || 'music'}`));
    };

    const handleEbookClick = () => {
        router.push(getPlatformLinkUsingRouter('/account/products/ebook'));
    };

    if (!isVisible || isAccount || router.pathname.startsWith('/account')) {
        return null;
    }

    return (
        <div className={styles['notification-banner']}>
            <div className={styles['notification-banner__content']}>
                <div className={styles['notification-banner__item']}>
                    <span className={styles['notification-banner__message']}>
                        Our Best Deals of the Year Are Now Live
                    </span>
                    <button
                        type="button"
                        onClick={handleDealsClick}
                        className={styles['notification-banner__action']}
                    >
                        View Offers
                    </button>
                </div>
                <div className={classNames(styles['notification-banner__item'], styles['notification-banner__item-hide-mobile'])}>
                    <span className={styles['notification-banner__message']}>
                        &ldquo;How to Build a 6-Figure DJ Career&rdquo; Ebook
                    </span>
                    <button
                        type="button"
                        onClick={handleEbookClick}
                        className={styles['notification-banner__action']}
                    >
                        Save 50%
                    </button>
                </div>
            </div>
            <button
                type="button"
                onClick={handleClose}
                className={styles['notification-banner__close']}
                aria-label="Close notification"
            >
                ✕
            </button>
        </div>
    );
}
